import React, { useEffect, useState } from "react";
import axios from "axios";
import "./NumberTaxiTables.css"; // אפשר ליצור קובץ עיצוב מותאם

const NumberTaxiForRentTable = () => {
  const [data, setData] = useState([]);
  const [openRow, setOpenRow] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("/api/numbertaxiforrent/all");
        if (res.data.success) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("שגיאה בשליפת נתונים", err);
      }
    };

    fetchData();
  }, []);

  const toggleRow = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  return (
<div className="number-sale-container">
<h2 className="NumberTaxiForSell-h2Title">זכויות ציבוריות להשכרה</h2>
  <table className="number-sale-table">
    <thead className="number-sale-thead">
      <tr className="number-sale-header-row">
        <th className="number-sale-th">סוג</th>
        <th className="number-sale-th">תאריך פינוי</th>
        <th className="number-sale-th">מחיר ללא מע"מ</th>
      </tr>
    </thead>
    <tbody className="number-sale-tbody">
      {data.map((item) => {
        const displayDate =
          item.Immediately === "כן" ? "מיידי" :
          new Date(item.Date).toLocaleDateString("he-IL");

        return (
          <React.Fragment key={item.id}>
            <tr
              onClick={() => toggleRow(item.id)}
              className="number-sale-clickable-row"
            >
              <td className="number-sale-td">{item.Type}</td>
              <td className="number-sale-td">{displayDate}</td>
              <td className="number-sale-td">{item.Price}</td>
            </tr>
            {openRow === item.id && (
              <tr className="number-sale-expanded-row">
                <td colSpan="3">
                  <div className="number-sale-expanded-content">
                    <p><strong>שם:</strong> {item.Name}</p>
                    <button
                      onClick={() => window.open(`tel:${item.Phone}`, "_blank")}
                      className="number-sale-button"
                    >
                      📞 התקשר ללקוח
                    </button>
                    <button
                      onClick={() => window.open(item.WhatsappLink, "_blank")}
                      className="number-sale-button"
                    >
                      💬 שלח הודעת וואטסאפ
                    </button>
                  </div>
                </td>
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </tbody>
  </table>
</div>

  );
};

export default NumberTaxiForRentTable;
